import { FC } from 'react';
import { PageTitle } from '../../../../rbts/layout/core';
import { View } from './components/View';

const TipoPuntoVentaPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Tipos de Punto de Venta</PageTitle>
      <View />
    </>
  );
};

export { TipoPuntoVentaPage };
